<template>
  <div class="banner1">
    <!-- 空格 -->
    <div class="kong"></div>
    <div class="container">
      <div class="left">
        <ul>
          <li>
            <div class="box">
              <img src="../assets/shape-al1.png">
            </div>
          </li>
          <li>
            <div class="box">
              <h5>所用产品分类</h5>
              <span>·阳光直发核收易</span>
            </div>
          </li>
          <li>
            <div class="box">
              <h5>采用业务模式</h5>
              <span>·跨境电商9610出口</span>
            </div>
          </li>
          <li>
            <div class="box">
              <h5>采用税务模式</h5>
              <span>·免税</span>
              <span>·企业所得税核定征收</span>
            </div>
          </li>
          <li>
            <div class="box">
              <h5>现行通关口岸</h5>
              <span>·上海</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="right">
        <div class="companyname">
          <h1>上海北潍贸易有限公司</h1>
        </div>
        <div class="text">
          <p class="title">企业背景</p>
          <p>
            上海亿品贸易有限公司成立于2010年，成立之初，便开始从事eBay平台的运营与销售，先后获得“eBay中国飞跃进步奖、eBay中国大卖家奖”等荣誉，并不断扩大经营范围，业务已扩展至亚马逊、速卖通、Wish、Shopee等电商平台。
          </p>
          <p class="title">现有痛点</p>
          <p>
            作为一家深耕跨境电商行业多年的企业，却始终未享受到跨境电商相应的优惠政策。随着企业业务量的快速增长，税负方面的成本也变得越来越高。因此，亿品期望能够在税务上实现合规的同时降低自己的税负成本。为解决这一痛点，亿品找到了阳光跨境平台，阳光跨境平台也根据亿品现有的业务模式，推荐企业采用平台的“阳光直发核收易”产品，来帮助企业享受跨境电商零售出口特有的企业所得税核定征收的优惠政策。
          </p>
          <p class="title">解决方案</p>
          <p>
            由于企业所得税核定征收方式要求企业的跨境电商零售出口业务占比必须在50%以上，亿品考虑到自己目前的业务模式比较多元化，在与阳光跨境平台的沟通与支持下，决定新注册一家专门开展跨境电商9610出口业务的企业。2月初，亿品确认委托阳光跨境平台注册新公司，在短短2周内，阳光跨境平台就帮助企业完成了新公司：上海北潍贸易有限公司的注册。此后，阳光跨境平台在短短一个多月内就帮助北潍完成了所有跨境电商通关资质的办理，为企业在正式开展跨境电商9610出口业务前做好了充分的准备。
          </p>
          <p class="title">服务评价</p>
          <p> 北潍对于阳光跨境平台提供的资质代办和平台入驻服务给予了高度肯定，也感谢阳光跨境平台在整个服务中的高度支持与配合。此外，北潍也认为阳光跨境平台确实能够帮助企业快速高效地解决业务的痛点与难点，是个非常不错的服务平台。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {};
    },
  };
</script>
<style scoped>
  .text p {
    font-size: 14px;
    line-height: 36px;
    text-indent: 2em;
    margin: 0 70px 20px 70px;
    min-height: auto;
  }

  .text .title {
    font-size: 16px;
    font-weight: bold;
    color: black;
    line-height: 36px;
    margin: 0 70px 0 20px;
  }

  .companyname h1 {
    font-size: 20px;
    font-weight: medium;
    text-align: center;
    color: black;
    padding: 0px 0px 35px 0px;
  }

  .left ul li:last-child {
    border-bottom: none;
  }

  .box span {
    display: block;
    font-size: 16px;
    color: #0f0f0f;
    line-height: 30px;
  }

  .box h5 {
    font-size: 12px;
    line-height: 20px;
    font-weight: 600;
    color: #009245;
  }

  .left ul li {
    display: block;
    border-bottom: 1px solid #e5e5e5;
    padding: 17px 20px 20px 60px;
  }

  .right {
    width: 650px;
    height: 1000px;
    background-color: #fff;
    float: right;
    box-shadow: 5px 5px 10px 0px #dfdfdf;
    border: 1px solid #e5e5e5;
    padding: 40px 60px 0px 60px;
    border-radius: 3px;
  }

  .left {
    height: 605px;
    width: 370px;
    background-color: #fff;
    float: left;
  }

  .kong {
    /* height: 125px; */
    height: 150px;
  }

  .banner1 {
    background-image: url("../assets/shape111.png");
    background-repeat: no-repeat;
  }

  .container {
    width: 1200px;
    margin: 0 auto !important;
    min-height: 1100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Examples.vue